import { Badge, Button } from "../../../../components";
import { BarChart3, Edit, EyeOff, Globe } from "lucide-react";

import { SurveyStatus, type SurveyAdminDetailResponse } from "../types/survey.types";

interface SurveyDetailToolbarProps {
  survey: SurveyAdminDetailResponse;
  onEdit: () => void;
  onResponses: () => void;
  onPublishToggle: () => void;
  isPublishing?: boolean;
}

export default function SurveyDetailToolbar({
  survey,
  onEdit,
  onResponses,
  onPublishToggle,
  isPublishing = false,
}: SurveyDetailToolbarProps) {
  const isPublished = survey.status !== SurveyStatus.Unpublished;
  return (
    <div className="flex items-center justify-between mb-6">
      <div className="flex items-center gap-2">
        <Badge
          variant={isPublished ? "default" : "secondary"}
          className="h-9 px-3 text-sm rounded-sm dark:bg-gray-600 dark:text-gray-200"
        >
          {isPublished ? survey.status : "Draft"}
        </Badge>
      </div>

      <div className="flex items-center gap-2">
        <Button
          variant="outline"
          size="sm"
          onClick={onEdit}
          className="flex items-center gap-2 dark:border-gray-600 dark:text-gray-200 dark:hover:bg-gray-700"
        >
          <Edit className="h-4 w-4" />
          Edit
        </Button>
        <Button
          variant="outline"
          size="sm"
          onClick={onResponses}
          className="flex items-center gap-2 dark:border-gray-600 dark:text-gray-200 dark:hover:bg-gray-700"
        >
          <BarChart3 className="h-4 w-4" />
          Responses
        </Button>
        <Button
          variant="outline"
          size="sm"
          onClick={onPublishToggle}
          disabled={isPublishing}
          className="flex items-center gap-2 dark:border-gray-600 dark:text-gray-200 dark:hover:bg-gray-700"
        >
          {isPublishing ? (
            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-current" />
          ) : isPublished ? (
            <EyeOff className="h-4 w-4" />
          ) : (
            <Globe className="h-4 w-4" />
          )}
          {isPublishing ? "Updating..." : isPublished ? "Unpublish" : "Publish"}
        </Button>
      </div>
    </div>
  );
}
